/**
 * @readonly
 * @enum {string}
 */
export const FuelLevelEventTypes = Object.freeze({
    TRIP: 'TRIP',
    IDLEINTERVAL: 'IDLEINTERVAL',
    FUEL_DECREASED_DRIVING: 'FUEL_DECREASED_DRIVING',
    FUEL_DECREASED_LEAKAGE: 'FUEL_DECREASED_LEAKAGE',
    FUEL_INCREASED_REFUEL: 'FUEL_INCREASED_REFUEL'
})
